// Utility per generare URL di thumbnail dinamiche per i link

const THUMBNAIL_CONFIG = {
  // Dimensioni standard Open Graph
  WIDTH: 1200,
  HEIGHT: 630,
  
  // URL del servizio di generazione thumbnail (eventuale)
  GENERATOR_URL: 'https://api.wanderbuddy.com/generate-thumbnail',
  
  // Thumbnails di default per ogni tipo di contenuto
  DEFAULTS: {
    trip: 'https://app.wanderbuddy.com/og-trip-default.png',
    profile: 'https://app.wanderbuddy.com/og-profile-default.png',
    general: 'https://app.wanderbuddy.com/og-default.png'
  }
};

/**
 * Genera URL thumbnail per un trip plan
 */
export const getTripThumbnail = (tripData, isShared = false) => {
  // Se hai un servizio di generazione thumbnail dinamiche
  if (tripData && tripData.destination) {
    try {
      const params = new URLSearchParams({
        type: 'trip',
        destination: tripData.destination,
        duration: tripData.duration || '',
        shared: isShared ? '1' : '0',
        activities: Array.isArray(tripData.activities) ? tripData.activities.slice(0, 3).join(', ') : String(tripData.activities || '')
      });
      
      // URL del servizio di generazione (da implementare se necessario)
      return `${THUMBNAIL_CONFIG.GENERATOR_URL}?${params}`;
    } catch (error) {
      console.warn('Error generating trip thumbnail:', error);
    }
  }
  
  // Fallback alla thumbnail di default
  return THUMBNAIL_CONFIG.DEFAULTS.trip;
};

/**
 * Genera URL thumbnail per un profilo utente
 */
export const getProfileThumbnail = (profileData) => {
  // Se hai un servizio di generazione thumbnail dinamiche
  if (profileData && profileData.nickname) {
    try {
      const params = new URLSearchParams({
        type: 'profile',
        nickname: profileData.nickname,
        name: profileData.name || '',
        tripsCount: profileData.tripsCount || '0',
        location: profileData.location || ''
      });
      
      // URL del servizio di generazione (da implementare se necessario)
      return `${THUMBNAIL_CONFIG.GENERATOR_URL}?${params}`;
    } catch (error) {
      console.warn('Error generating profile thumbnail:', error);
    }
  }
  
  // Fallback alla thumbnail di default
  return THUMBNAIL_CONFIG.DEFAULTS.profile;
};

/**
 * Genera URL thumbnail per invito pubblico chat
 */
export const getInviteThumbnail = (room, tripPlan) => {
  try {
    const params = new URLSearchParams({
      type: 'invite',
      roomName: room?.name || 'Group',
      destination: tripPlan?.destination || '',
      creator: room?.creatorNickname || ''
    });
    return `${THUMBNAIL_CONFIG.GENERATOR_URL}?${params}`;
  } catch (e) {
    return THUMBNAIL_CONFIG.DEFAULTS.general;
  }
};

/**
 * Genera URL thumbnail per chat room
 */
export const getChatThumbnail = (chatData) => {
  try {
    const params = new URLSearchParams({
      type: 'chat',
      name: chatData?.name || 'Chat',
      destination: chatData?.destination || '',
      memberCount: String(chatData?.memberCount || '')
    });
    return `${THUMBNAIL_CONFIG.GENERATOR_URL}?${params}`;
  } catch (e) {
    return 'https://app.wanderbuddy.com/og-chat.png';
  }
};

/**
 * Genera URL thumbnail generica (fallback)
 */
export const getDefaultThumbnail = (type = 'general') => {
  return THUMBNAIL_CONFIG.DEFAULTS[type] || THUMBNAIL_CONFIG.DEFAULTS.general;
};

/**
 * Valida se un URL di immagine è accessibile
 */
export const validateImageUrl = async (imageUrl) => {
  try {
    const response = await fetch(imageUrl, { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    return false;
  }
};

/**
 * Genera meta tags Open Graph completi per un contenuto
 */
export const generateOGTags = (content) => {
  const {
    title = 'WanderBuddy - Il tuo compagno di viaggio intelligente',
    description = 'Scopri itinerari personalizzati e pianifica i tuoi viaggi con l\'intelligenza artificiale',
    image = THUMBNAIL_CONFIG.DEFAULTS.general,
    url = 'https://app.wanderbuddy.com/',
    type = 'website'
  } = content;

  return {
    'og:title': title,
    'og:description': description,
    'og:image': image,
    'og:url': url,
    'og:type': type,
    'og:site_name': 'WanderBuddy',
    'og:locale': 'it_IT',
    'og:image:width': THUMBNAIL_CONFIG.WIDTH.toString(),
    'og:image:height': THUMBNAIL_CONFIG.HEIGHT.toString(),
    'og:image:type': 'image/png',
    
    // Twitter Card
    'twitter:card': 'summary_large_image',
    'twitter:title': title,
    'twitter:description': description,
    'twitter:image': image,
    'twitter:site': '@WanderBuddy'
  };
};
